import MuiSlide, { type SlideProps } from "@mui/material/Slide";

export type { SlideProps };

export function Slide(props: SlideProps) {
  return <MuiSlide {...props} />;
}
